import { AnimatePresence } from 'motion/react';

import { Icons } from '@/assets/icons/icons';
import { YStack } from '@/components/ui/layout/layout';

import { FieldLabel } from './field-label';

export function EditableList({
  label,
  addLabel,
  onAdd,
  children,
}: {
  label: string;
  addLabel: string;
  onAdd: () => void;
  children: React.ReactNode;
}) {
  return (
    <YStack className="gap-2">
      <FieldLabel optional>{label}</FieldLabel>
      <AnimatePresence initial={false}>{children}</AnimatePresence>
      <button
        type="button"
        onClick={onAdd}
        className="flex items-center gap-1.5 self-start py-1 text-xs text-foreground-muted hover:text-foreground"
      >
        <Icons.plus className="size-3.5" />
        {addLabel}
      </button>
    </YStack>
  );
}
